import { Box, styled, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import * as React from 'react';
import { ReactNode } from 'react';
import { Constants } from '../config/constants';

const HeaderAreaBackground = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.blue.light,
  paddingTop: '1rem',
  paddingBottom: '1rem',
  width: '100%',
  height: 'auto',
  boxShadow: `0 0 0 100vmax ${theme.palette.blue.light}`,
  clipPath: 'inset(0 -100vmax)',
  maxWidth: Constants.bodyMaxWidth,
  margin: '0 auto'
}));

interface IHeaderAreaProps {
  title: string | ReactNode;
  image?: string;
  button?: ReactNode;
  children: ReactNode;
}

export const HeaderArea = ({
  title,
  children,
  image,
  button
}: IHeaderAreaProps) => {
  return (
    <HeaderAreaBackground>
      <Typography gutterBottom variant="h5" component="div" sx={{ pb: 1 }}>
        {title}
      </Typography>
      <Grid
        container
        sx={{ flexDirection: { sm: 'row', xs: 'column-reverse' } }}
      >
        <Grid sm xs={12}>
          <Typography sx={{ mb: '1rem' }}>{children}</Typography>
        </Grid>
        {image && (
          <Grid sm="auto" xs={12} sx={{ alignSelf: 'center' }}>
            <Box
              sx={{
                width: {
                  sm: 120,
                  xs: '100%'
                },
                height: 120,
                m: 1
              }}
              component="img"
              src={image}
            />
          </Grid>
        )}
      </Grid>
      {button}
    </HeaderAreaBackground>
  );
};
